export default __webpack_public_path__ + "static/media/redCubeSide.d06b881e.svg";